/*
 *
 * Login
 *
 */

import "./styles.scss";

import { API, Endpoints } from "utils/api";
import { Input, notification } from "antd";
import { setBusiness, setLoader, setToken, setUser } from "store/actions";

import { Footer } from "screens";
import { Helmet } from "react-helmet";
import { Icons } from "components";
import React from "react";
import { RotateSpinner } from "react-spinners-kit";
import Strings from "utils/strings";
import { connect } from "react-redux";
import { consumePostLoginRedirect } from "screens/App/routes";
import { push } from "connected-react-router";

export class Login extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			email: "",
			password: "",
			showPassword: false,

			signingIn: false,
			isMobile: window.innerWidth <= 768
		};

		this.handleResize = this.handleResize.bind(this);
		window.addEventListener("resize", this.handleResize);
	}

	componentDidMount() {
		this.handleResize();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	handleResize() {
		this.setState({ isMobile: window.innerWidth <= 768 });
	}

	async login() {
		const { email, password } = this.state;
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			const body = {
				email,
				password
			};

			response = await API.post({
				url: Endpoints.uriLogin(),
				data: body
			});

			console.log(response);

			if (response?.data?.code === "PASSWORD_EXPIRED") {
				console.log("YO");
				dispatch(push(`/change-expired-password?email=${encodeURIComponent(email)}`));
			} else if (response.ok) {
				const { user, business, token } = response.data.results || {};
				dispatch(setUser(user));
				if (business) dispatch(setBusiness(business));
				dispatch(setToken(token));

				// Return to the internal path saved before the redirect to /login (e.g. /profile/:code).
				const postLoginRedirect = consumePostLoginRedirect();
				if (postLoginRedirect) dispatch(push(postLoginRedirect));
			} else {
				notification.error({
					message: Strings.authentication.header,
					description: Strings.serverErrors.invalidCredentials,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.authentication.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	render() {
		const { signingIn, email, password, showPassword } = this.state;
		const { dispatch, mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.authentication.login} | Team24</title>
					<meta name="description" content="Description of Login" />
				</Helmet>
				<div className="LoginContent">
					<div className="LoginContentWrapper">
						<div className="LoginBox">
							<div className="LoginWelcome" />
							<div className="LoginWrapper">
								<div className="LoginBackground" />
								<div className="LoginForm">
									<h1>{Strings.authentication.login}</h1>
									<h3>{Strings.authentication.typeCredentials}</h3>
									<form
										onSubmit={(e: any) => {
											e.preventDefault();
											e.stopPropagation();

											if (!signingIn) {
												this.login();
											}
										}}
									>
										<Input
											placeholder={Strings.placeholders.email}
											className="LoginInputClass"
											value={email}
											type="email"
											required
											prefix={<Icons.Message smaller />}
											onChange={(e: any) => this.setState({ email: e.target.value })}
										/>
										<Input
											placeholder="••••••••"
											className="LoginInputClass"
											value={password}
											type={showPassword ? "text" : "password"}
											required
											prefix={<Icons.Lock />}
											suffix={
												<button
													onClick={(e: any) => {
														e.preventDefault();
														e.stopPropagation();

														// if (this.state.mouseHover) {
														this.setState((prevState: any) => ({
															showPassword: !prevState.showPassword
														}));
														// }
													}}
													type="button"
													// onMouseEnter={() => this.setState({ mouseHover: true })}
													// onMouseLeave={() => this.setState({ mouseHover: false })}
													className="LoginInputPasswordViewer"
												>
													<Icons.Eye />
												</button>
											}
											onChange={(e: any) => this.setState({ password: e.target.value })}
										/>
										<div className="LoginOptions">
											<a
												href="/recover-password"
												onClick={(e: any) => {
													e.preventDefault();
													dispatch(push("/recover-password"));
												}}
												className="LoginOptionLink"
											>
												{Strings.authentication.forgotPassword}
											</a>
											<a
												href="/confirm-account"
												onClick={(e: any) => {
													e.preventDefault();
													dispatch(push("/confirm-account"));
												}}
												className="LoginOptionLink --no-decoration"
											>
												{Strings.authentication.loginConfirmAccount}{" "}
												<span>{Strings.authentication.loginConfirmAccount2}</span>
											</a>
										</div>
										<button type="submit" className="LoginButtonClass">
											{signingIn ? (
												<div className="LoadingSpinner">
													<RotateSpinner size={24} color="#FFFFFF" />
												</div>
											) : (
												Strings.authentication.signIn
											)}
										</button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
				{mobile && <Footer />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	user: state.user,
	mobile: state.mobile
});

export default connect(mapStateToProps)(Login);
